import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { State } from 'b2b-apps/shop/common/redux/types';
import { WishlistsType } from 'b2b-common/core/account/api/wishlists';
import { WishlistsState } from './types';

export const getState = (state: State): WishlistsState => state.myAccount.wishlists.wishlists;

export const getWishlists = (state: State): RemoteRecord<WishlistsType> => new RemoteRecord(getState(state));
